import React from 'react';

const userSelf = {};
const UserSelfContext = React.createContext(userSelf);

export default UserSelfContext;
